/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay.clientSubstatusOverlay{height:100%}.overlay.clientSubstatusOverlay .ol-main .ol-content{padding:0;overflow:auto;height:100%}.overlay.clientSubstatusOverlay .ol-main .ol-content .content{margin-bottom:40px}"];
export { styles as styles };
